export const getKey = (key: string) => `mx:auth:${key}`;

export const setItem = (key: string, value: string) => localStorage.setItem(getKey(key), value);
export const getItem = (key: string) => localStorage.getItem(getKey(key));
export const removeItem = (key: string) => localStorage.removeItem(getKey(key));
